{
  "dss": {
    "footer": {
      "legalEntity": "STIHL PTY. LTD."
    },
    "link": {
      "contact": "https://support.stihl.com/en-au/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-au/externalkbsearchwebsso/"
    }
  }
}
